import { ApiType } from "@gymflow/common";
import { TaskDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import merge from "lodash/merge";

import { deadlineDatesToZonedTime } from "./deadlineDatesToZonedTime";
import { taskQueryKeys } from "./taskQueryKeys";

export function useTask(
  {
    api,
    taskId,
    tz,
  }: {
    api: ApiType;
    taskId?: number;
    tz: string;
  },
  opts?: Omit<UseQueryOptions<TaskDTO | null>, "queryKey">,
) {
  return useQuery({
    queryKey: taskQueryKeys.details(taskId),
    queryFn: async () => {
      return (await api.taskApi.findById(taskId!)).data;
    },
    enabled: !!taskId,
    select: (data: TaskDTO | null) => {
      if (data) {
        return merge({}, data, deadlineDatesToZonedTime(data, tz)) as TaskDTO;
      }
      return data;
    },
    ...opts,
  });
}
